import { globalState } from './globalState'

export const removeDialog = (): void => {
    const config = globalState.getConfig()
    const cxf = globalState.getCxf()
    cxf.emit(config.CXF_DIALOG_CLOSE)
}

export const createDialog = (url: string): void => {
    const config = globalState.getConfig()
    const cxf = globalState.getCxf()
    cxf.emit(config.CXF_DIALOG_OPEN, url)
}
